import { useCallback, useState } from 'react';
import { FormikHelpers } from 'formik';
import useReferral from 'data/hooks/useReferral';
import { initialValues, validationSchema } from './constants';

type FormValues = typeof initialValues;

const useConnect = () => {
  const { referral } = useReferral();
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = useCallback(
    async (values: FormValues, { setErrors }: FormikHelpers<FormValues>) => {
      try {
        await referral(values);
        setShowModal(true);
      } catch (error) {
        setErrors({
          // @ts-ignore
          ...error.fields,
          // @ts-ignore
          phoneNumber: error.fields.phone || undefined,
        });
      }
    },
    [referral],
  );

  return {
    handleSubmit,
    initialValues,
    validationSchema,
    showModal,
    setShowModal,
  };
};

export default useConnect;
